import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid } from '@mui/material';
import CommonTable from 'components/commonTable/CommonTable';
// import FeedbackFilter from './FeedBackFilter';
import CommonDateRangePicker from 'pages/date/CommonDateRangePicker';
import FeedBackHeader from './FeedBackHeader';
import CommonFilter from 'components/commonFilter/CommonFilter';
import Loader from 'components/loader/Loader';

function FeedbackTab(props) {
 
  const handleChange = (event, newValue) => {
    props?.handleChange(newValue)
  };

  const onClickTableFeedback = (data) => {
    props.onClickTableFeedback(data)
  }

  return (
    <Grid container>
      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle marginBlock10">
          <TabContext value={props?.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              {/* <Grid item>
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  xs={6}
                > */}
                  {/* <Tab label="Driver" value="Driver" className="tabStyle" /> */}
                  {/* <Tab label="Trip" value="Customer" className="tabStyle" /> */}
                {/* </TabList>
              </Grid> */}

              <Grid
                item
                container
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                xs={12}
                className='mb15'
              >
                <Grid item>
                  <CommonDateRangePicker onSelectDateRange={props?.onSelectDateRange} tabName={props?.tabName} />
                </Grid>
                <Grid item mx={2}>
                  {/* <FeedbackFilter /> */}
                  <CommonFilter defaultStatus={props?.defaultStatus} filterdata={props?.filterData} onFilterChange={props?.onFilterChange} onRestFilter={props?.onRestFilter} />
                </Grid>
              </Grid>
            </Grid>
            <FeedBackHeader tableData={props?.tableData} onRating={props?.onRating} status={props?.status}/>
            <TabPanel value="Driver" className="tabPanelStyle">
              {props?.isLoading? <Loader /> : <CommonTable data={props?.tableData} onClickTableVendor={onClickTableFeedback} 
              handleChangePage={props?.handleChangePage}
              handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
              page={props?.page}
              isClickable = {false}
              rowsPerPage={props?.rowsPerPage} />}
            </TabPanel>
            <TabPanel value="Customer" className="tabPanelStyle">
              {props?.isLoading ? <Loader /> : <CommonTable data={props?.tableData} onClickTableVendor={onClickTableFeedback} 
              handleChangePage={props?.handleChangePage}
              handleChangeRowsPerPage={props?.handleChangeRowsPerPage}
              page={props?.page}
              isClickable = {false}
              rowsPerPage={props?.rowsPerPage}/>}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default FeedbackTab;
